module.exports = __webpack_public_path__ + "static/img/ronghejicheng.506f528.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/homePage/ronghejicheng.gif
// module id = +Cq/
// module chunks = 0